import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {VehicleConfiguratorLeadTrackingDataValueObject} from '../ValueObjects/VehicleConfiguratorLeadTrackingDataValueObject.js'

class GetVehicleConfiguratorLeadTrackingDataUseCase extends UseCase {
  static create() {
    return new GetVehicleConfiguratorLeadTrackingDataUseCase()
  }

  @tracer({metric: 'GetVehicleConfiguratorLeadTrackingDataUseCase#execute'})
  @AsyncInlineError()
  async execute({contactRequestId, brand, brandId, dealerId, distance, model, modelId, zipcode}) {
    const vehicleConfiguratorLeadTrackingDataValueObject = VehicleConfiguratorLeadTrackingDataValueObject.create({
      contactRequestId,
      brand,
      brandId,
      dealerId,
      distance,
      model,
      modelId,
      zipcode
    })

    return vehicleConfiguratorLeadTrackingDataValueObject
  }
}

export const factory = GetVehicleConfiguratorLeadTrackingDataUseCase.create
